import React, { useState, useEffect, useRef } from "react"
import { Input, Button, Checkbox } from "semantic-ui-react"
import { useTranslation } from "react-i18next"
import {
  INITIATED_BY_USER,
  ACTIVE,
  APPROVAL,
  AWAITING_APPROVAL,
  PRICE_REVIEW
} from "../../constants/statuses"
import { isFleetAdvise, isMobilease } from "../../helpers/affiliationHelpers"
import { EVENTS, FILTER_OPTIONS_ACTIVE_ORDER } from "../../constants/application"

export default function ServiceSearch({
  debouncedOnFilterChange,
  orderFilter = "",
  isActivePage,
  handlechange,
  handleResetFilterCallback,
  fieldValue,
  onOptionChange,
  selectedOption,
  onTextChange,
  searchText,
  onSearch
}) {
  const [orderStatuses, setOrderStatuses] = useState({
    isActiveOrderChecked: false,
    isApprovalOrderChecked: false,
    isApprovedOrderChecked: false
  })

  const { t } = useTranslation("services")

  useEffect(() => {
    if (
      orderFilter.includes(ACTIVE) ||
      orderFilter.includes(INITIATED_BY_USER) ||
      orderFilter.includes(PRICE_REVIEW)
    ) {
      setOrderStatuses({ isActiveOrderChecked: true })
    } else if (orderFilter.includes(AWAITING_APPROVAL)) {
      setOrderStatuses({ isApprovalOrderChecked: true })
    } else if (orderFilter.includes(APPROVAL)) {
      setOrderStatuses({ isApprovedOrderChecked: true })
    }

    handleResetFilterCallback(handleResetFileter)
  }, [])

  const handleResetFileter = () => {
    setOrderStatuses({
      isActiveOrderChecked: false,
      isApprovalOrderChecked: false,
      isApprovedOrderChecked: false
    })
  }

  const [showDropdown, setShowDropdown] = useState(false)
  const wrapperRef = useRef(null)

  useEffect(() => {
    if (!showDropdown) return

    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [showDropdown])

  const handleKeyDown = (event) => {
    if (event.key === EVENTS.ENTER) {
      this.onSearch()
    }
  }

  return (
    <div className="flex items-center gap-2">
      {isActivePage && (
        <div className="search-input-parent">
          <div className="search-input-box-vehicle">
            <Input
              className="search"
              onChange={onTextChange}
              icon="search"
              placeholder={t("searchServicesLabel")}
              value={searchText}
              onClick={() => setShowDropdown(true)}
              onKeyDown={handleKeyDown}
            />
            {showDropdown && (
              <div className="filter-options-parent" ref={wrapperRef}>
                <p>{t("iAmLookingForLabel")}</p>
                <div className="filter-options">
                  {FILTER_OPTIONS_ACTIVE_ORDER.map((option) => (
                    <label key={option.value}>
                      <input
                        type="radio"
                        value={option.value}
                        checked={option.value === selectedOption}
                        onChange={onOptionChange}
                        className={isFleetAdvise() || isMobilease() ? "radio-btn-color" : ""}
                      />
                      {option.key}
                      <br />
                    </label>
                  ))}
                </div>
              </div>
            )}
          </div>
          <Button disabled={!(searchText.length >= 1)} onClick={onSearch}>
            {t("search")}
          </Button>
        </div>
      )}
      {!isActivePage && (
        <Input
          className="search"
          onChange={debouncedOnFilterChange}
          icon="search"
          placeholder={t("searchServicesLabel")}
          value={fieldValue}
        />
      )}
      {isActivePage && (
        <>
          &nbsp;
          <Checkbox
            label={t("activeOrdersLabel")}
            checked={orderStatuses.isActiveOrderChecked}
            onChange={(e, value) =>
              handlechange(e, [INITIATED_BY_USER, ACTIVE, PRICE_REVIEW], setOrderStatuses, value)
            }
            className={isFleetAdvise() || isMobilease() ? "size-to-fit" : ""}
          />
          &nbsp;
          <Checkbox
            label={t("needsApprovalLabel")}
            checked={orderStatuses.isApprovalOrderChecked}
            onChange={(e, value) => handlechange(e, [AWAITING_APPROVAL], setOrderStatuses, value)}
            className={isFleetAdvise() || isMobilease() ? "size-to-fit" : ""}
          />
          &nbsp;
          <Checkbox
            label={t("approvedLabel")}
            checked={orderStatuses.isApprovedOrderChecked}
            onChange={(e, value) => handlechange(e, [APPROVAL], setOrderStatuses, value)}
            className={isFleetAdvise() || isMobilease() ? "size-to-fit" : ""}
          />
        </>
      )}
    </div>
  )
}
